import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  ElementRef,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core'

import { YoutubePlayerService, PlayerSize } from './shared/youtube-player.service'

@Component({
  selector: 'cm-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubePlayerComponent implements OnInit, OnChanges {

  @Input() url: string
  @Input() width: number
  @Input() height: number
  @Input() playerVars: YT.PlayerVars = {}

  @Output() ready = new EventEmitter<YT.Player>()
  @Output() change = new EventEmitter()

  @ViewChild('ytPlayerContainer')
  private ytPlayerContainer: ElementRef

  private loaded = false

  constructor(private youtubePlayerService: YoutubePlayerService) { }

  ngOnInit() {
    this.youtubePlayerService.loadPlayerApi()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url && changes.url.currentValue) {
      this.loadVideo()
    }
  }

  private loadVideo() {
    const htmlId = this.youtubePlayerService.generateUniqueId()
    this.ytPlayerContainer.nativeElement.setAttribute('id', htmlId)

    const playerSize: PlayerSize = {
      width: this.width,
      height: this.height
    }

    this.youtubePlayerService.setupPlayer(htmlId, {
      ready: this.ready,
      change: this.change
    }, playerSize, this.url, this.playerVars)
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/youtube-player/youtube-player.component.ts